var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);
var scrollTo = require( 'scrollTo' );

var Maintenance = function () {
	this.$scrollTo = $( document.getElementsByClassName( 'scroller' ) );
};

Maintenance.prototype.init = function () {

	var self = this;

	self.$scrollTo.click( function ( e ) {
		e.preventDefault();

		$.scrollTo( $( this ).attr( 'href' ), 400, { offset: 1 } );
	} );
};

module.exports = new Maintenance;
